function refreshTokenWhenReceive({ store }) {
  function onFulfilled(response) {
    if (response.headers.authorization) {
      const token = response.headers.authorization.replace('Bearer ', '');

      store.commit('auth/setAccessToken', token);
    }

    return response;
  }

  function onRejected(error) {
    return Promise.reject(error);
  }

  return [onFulfilled, onRejected];
}

export default refreshTokenWhenReceive;
